const state = {
    userdetails:null,
};

const getters = {
    getUserdetails: state => state.userdetails,
};

const actions = {
    setUserdetails: (store, payload) => store.commit('USERDETAILS_SET',payload),
};

const mutations = {
    USERDETAILS_SET: (state, payload) => state.userdetails = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
